<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <div id="pnlButtonBar">
          <div class="btn-group">
            <button type="button" id="btnTerug" class="btn btn-primary btn-xs" @click.prevent="btnTerug">
              <font-awesome-icon icon="chevron-left" />
              {{ translation(14941) }}
            </button>
            <button
              type="button"
              id="btnOpslaan"
              class="btn btn-primary btn-xs"
              @click.prevent="btnOpslaan"
              v-if="!this.$route.params.bestuurderid"
            >
              <font-awesome-icon :icon="['far', 'save']" />
              {{ translation(14942) }}
            </button>
            <button
              type="button"
              id="btnOpslaanUpdate"
              class="btn btn-primary btn-xs"
              @click.prevent="btnOpslaanUpdate"
              v-if="this.$route.params.bestuurderid"
            >
              <font-awesome-icon :icon="['far', 'save']" />
              {{ translation(14942) }}
            </button>
          </div>
        </div>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(14938) }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p v-html="translation(14939)"></p>
      </div>
    </div>
    <fieldset class="margin20 margin20bottom">
      <XVbootstraprow
        :label="translation(14920)"
        :haserror="errors.has('tbxNaam')"
        :errormessage="errors.first('tbxNaam')"
        :required="true"
        class="margin20"
      >
        <XVinput
          id="tbxNaam"
          name="tbxNaam"
          v-model="bestuurder.tbxNaam"
          type="text"
          v-validate="'required|max:500'"
          :data-vv-as="translation(14920)"
        ></XVinput>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14925)"
        :required="true"
        :haserror="errors.has('rbAard')"
        :errormessage="errors.first('rbAard')"
      >
        <XVradiobuttonlist
          id="rbAard"
          v-model="bestuurder.rbAard"
          :datalist="[
            { value: 1, labelText: translation(14934) },
            { value: 2, labelText: translation(14933) },
          ]"
          v-validate="'required'"
          name="rbAard"
          :data-vv-as="translation(14925)"
          v-on:formvaluechanged="toggleBestuurderAard"
        ></XVradiobuttonlist>
      </XVbootstraprow>
      <div v-show="bestuurderRijksNrVerplicht">
        <XVbootstraprow
          :label="translation(14921)"
          :haserror="errors.has('tbxVoornaam')"
          :errormessage="errors.first('tbxVoornaam')"
        >
          <XVinput
            id="tbxVoornaam"
            name="tbxVoornaam"
            v-model="bestuurder.tbxVoornaam"
            type="text"
            v-validate="'max:100'"
            :data-vv-as="translation(14921)"
          ></XVinput>
        </XVbootstraprow>
        <XVbootstraprow
          :label="translation(14922)"
          :haserror="errors.has('tbxInitialen')"
          :errormessage="errors.first('tbxInitialen')"
        >
          <XVinput
            id="tbxInitialen"
            v-model="bestuurder.tbxInitialen"
            name="tbxInitialen"
            type="text"
            v-validate="'max:250'"
            :data-vv-as="translation(14922)"
          ></XVinput>
        </XVbootstraprow>
        <XVbootstraprow
          :label="translation(14984)"
          :required="bestuurderRijksNrVerplicht"
          :haserror="errors.has('tbxRijksregisternummer')"
          :errormessage="errors.first('tbxRijksregisternummer')"
        >
          <XVinput
            id="tbxRijksregisternummer"
            v-model="bestuurder.tbxRijksregisternummer"
            v-validate="rijksregNrVal"
            name="tbxRijksregisternummer"
            :data-vv-as="translation(14984)"
            v-on:formvaluechanged="rijksregNrOnChange"
          ></XVinput>
        </XVbootstraprow>
      </div>
      <XVbootstraprow
        v-if="bestuurderOndernNrVerplicht"
        :label="translation(14981)"
        :required="bestuurderOndernNrVerplicht"
        :haserror="errors.has('tbxOndernemingsnummer')"
        :errormessage="errors.first('tbxOndernemingsnummer')"
      >
        <XVinput
          id="tbxOndernemingsnummer"
          v-model="bestuurder.tbxOndernemingsnummer"
          v-validate="ondernemingsNrVal"
          name="tbxOndernemingsnummer"
          :data-vv-as="translation(14981)"
        ></XVinput>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14923)"
        :haserror="errors.has('tbxFunctie')"
        :errormessage="errors.first('tbxFunctie')"
      >
        <XVinput
          id="tbxFunctie"
          v-model="bestuurder.tbxFunctie"
          v-validate="'max:500'"
          name="tbxFunctie"
          :data-vv-as="translation(14923)"
        ></XVinput>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14924)"
        :required="true"
        :haserror="errors.has('rbActiefKredietbemiddeling')"
        :errormessage="errors.first('rbActiefKredietbemiddeling')"
      >
        <XVradiobuttonlist
          id="rbActiefKredietbemiddeling"
          v-model="bestuurder.rbKredietbemiddeling"
          :datalist="[
            { value: 1, labelText: translation(14931) },
            { value: 2, labelText: translation(14932) },
          ]"
          v-validate="'required'"
          name="rbActiefKredietbemiddeling"
          :data-vv-as="translation(14924)"
        ></XVradiobuttonlist>
      </XVbootstraprow>
      <div v-show="bestuurderOndernNrVerplicht">
        <XVbootstraprow
          :label="translation(14926)"
          :required="bestuurderOndernNrVerplicht"
          :haserror="errors.has('tbxVertegenwoordiger')"
          :errormessage="errors.first('tbxVertegenwoordiger')"
        >
          <XVinput
            id="tbxVertegenwoordiger"
            v-model="bestuurder.tbxVertegenwoordiger"
            v-validate="vertegenwoordigerVal"
            name="tbxVertegenwoordiger"
            :data-vv-as="translation(14926)"
          ></XVinput>
        </XVbootstraprow>
        <XVbootstraprow
          :label="translation(15175)"
          :required="bestuurderOndernNrVerplicht"
          :haserror="errors.has('tbxVertegenwoordigerRijksregnr')"
          :errormessage="errors.first('tbxVertegenwoordigerRijksregnr')"
        >
          <XVinput
            id="tbxVertegenwoordigerRijksregnr"
            v-model="bestuurder.tbxVertegenwoordigerRijksregnr"
            v-validate="vertrijksregNrVal"
            name="tbxVertegenwoordigerRijksregnr"
            :data-vv-as="translation(15175)"
            v-on:formvaluechanged="vertegenwoordigerrijksregNrOnChange"
          ></XVinput>
        </XVbootstraprow>
      </div>
      <XVbootstraprow
        :label="translation(14927)"
        :required="true"
        :haserror="errors.has('tbxDatumActief')"
        :errormessage="errors.first('tbxDatumActief')"
      >
        <XVdate
          id="tbxDatumActief"
          name="tbxDatumActief"
          v-model.trim="bestuurder.iDatumactief"
          :data-vv-as="translation(14927)"
          v-validate="{ XVDateDefault: true, required: true }"
        ></XVdate>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14928)"
        :haserror="errors.has('tbxDatumInactief')"
        :errormessage="errors.first('tbxDatumInactief')"
      >
        <XVdate
          id="tbxDatumInactief"
          name="tbxDatumInactief"
          v-model.trim="bestuurder.iDatumInactief"
          :data-vv-as="translation(14928)"
          v-validate="{ XVDateDefault: true }"
        ></XVdate>
        <span class="form-group__message">{{ errors.first('tbxDatumInactief') }}</span>
      </XVbootstraprow>
      <XVbootstraprow :label="translation(14929)">
        <XVtextarea id="tbaOpmerking" v-model="bestuurder.tbaOpmerking" name="tbaOpmerking"></XVtextarea>
      </XVbootstraprow>
      <XVbootstraprow
        key="uploadNameRow"
        :label="translation(14930)"
        :required="true"
        :haserror="errors.has('uploadName')"
        :errormessage="errors.first('uploadName')"
      >
        <XVupload
          v-validate="'required|minuploads:1'"
          maximumfilecount="1"
          name="uploadName"
          :data-vv-as="translation(14930)"
          v-model="bestuurder.uploadfiles"
        ></XVupload>
      </XVbootstraprow>
    </fieldset>
  </div>
</template>

<script>
import { FAMixin, util } from 'pevueglobal'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import XVupload from '@/components/XVupload'
import { sync } from 'vuex-pathify'
import Vue from 'vue'
export default {
  mixins: [FAMixin],
  components: {
    XVupload,
  },
  data: function () {
    return {}
  },
  async created() {
    if (this.bestuurdersTable.tablecolumnsetting.length === 0) {
      if (this.$route.params.personid) {
        this.$router.push({ name: 'VMSWbestuurdersInzien', params: { personid: this.$route.params.personid } })
      } else {
        this.$router.push({ name: 'VMSWbestuurders' })
      }
    } else {
      if (this.$route.params.bestuurderid) {
        await this.makeUpdateBestuurderDetail(this.$route.params.bestuurderid)
      }
    }
    this.stopLoading()
  },
  mounted() {},
  computed: {
    ...mapGetters('VMSWbestuurdersAandeelhouders', [
      'bestuurdersTable',
      'bestuurderRijksNrVerplicht',
      'bestuurderOndernNrVerplicht',
    ]),
    bestuurder: sync('VMSWbestuurdersAandeelhouders/bestuurder'),
    rijksregNrVal: function () {
      if (this.bestuurder.rbAard === 1) {
        return 'required: true|max:50|IsRRNoValid'
      } else {
        return ''
      }
    },
    vertegenwoordigerVal: function () {
      if (this.bestuurder.rbAard === 2) {
        return 'required|max:500'
      } else {
        return ''
      }
    },
    vertrijksregNrVal: function () {
      if (this.bestuurder.rbAard === 2) {
        return 'required: true|max:50|IsRRNoValid'
      } else {
        return ''
      }
    },
    ondernemingsNrVal: function () {
      if (this.bestuurder.rbAard === 2) {
        return 'required: true|max:50'
      } else {
        return ''
      }
    },
  },
  methods: {
    ...mapActions('VMSWbestuurdersAandeelhouders', ['insertBestuurder', 'updateBestuurder']),
    ...mapMutations('VMSWbestuurdersAandeelhouders', ['makeUpdateBestuurderDetail', 'toggleBestuurderAard']),
    ...mapMutations(['addNotification']),
    btnTerug: function () {
      if (this.$route.params.personid) {
        this.$router.push({ name: 'VMSWbestuurdersInzien' })
      } else {
        this.$router.push({ name: 'VMSWbestuurders' })
      }
    },

    btnOpslaan: function () {
      this.$validator.validate().then((result) => {
        if (result) {
          let opmerking = this.bestuurder.tbaOpmerking
          if (this.bestuurder.tbaOpmerking === '') {
            opmerking = null
          }
          let bestuurderData = {
            tblVMSWBestuurderNaam: this.bestuurder.tbxNaam,
            tblVMSWBestuurderVoornaam: this.bestuurder.tbxVoornaam,
            tblVMSWBestuurderAndereVoornamen: this.bestuurder.tbxInitialen,
            tblVMSWBestuurderFunctie: this.bestuurder.tbxFunctie,
            tblVMSWBestuurderActiefKrediet: this.bestuurder.rbKredietbemiddeling,
            tblVMSWBestuurderAard: this.bestuurder.rbAard,
            tblVMSWBestuurderVasteVertegenwoordiger: this.bestuurder.tbxVertegenwoordiger,
            tblVMSWBestuurderDatumActief: util.DateForDatabase(this.bestuurder.iDatumactief),
            tblVMSWBestuurderDatumInactief: util.DateForDatabase(this.bestuurder.iDatumInactief),
            tblVMSWBestuurderOpmerking: opmerking,
            tblVMSWBestuurderVerklaringFMSA: this.bestuurder.uploadfiles[0].uploadFileID,
            tblVMSWBestuurderRijksregisterNummer: this.bestuurder.tbxRijksregisternummer,
            tblVMSWBestuurderOndernemingsnummer: this.bestuurder.tbxOndernemingsnummer,
            tblVMSWBestuurderVasteVertegenwoordigerRijksregisterNummer: this.bestuurder.tbxVertegenwoordigerRijksregnr,
          }
          if (this.$route.params.personid) {
            Vue.set(bestuurderData, 'tblpersonid', parseInt(this.$route.params.personid))
          }
          this.insertBestuurder(bestuurderData)
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
    btnOpslaanUpdate: function () {
      this.$validator.validate().then((result) => {
        if (result) {
          let opmerking = this.bestuurder.tbaOpmerking
          if (this.bestuurder.tbaOpmerking === '') {
            opmerking = null
          }

          let bestuurderUpdateData = {
            tblVMSWBestuurderID: this.$route.params.bestuurderid,
            tblVMSWBestuurderNaam: this.bestuurder.tbxNaam,
            tblVMSWBestuurderVoornaam: this.bestuurder.tbxVoornaam,
            tblVMSWBestuurderAndereVoornamen: this.bestuurder.tbxInitialen,
            tblVMSWBestuurderFunctie: this.bestuurder.tbxFunctie,
            tblVMSWBestuurderActiefKrediet: this.bestuurder.rbKredietbemiddeling,
            tblVMSWBestuurderAard: this.bestuurder.rbAard,
            tblVMSWBestuurderVasteVertegenwoordiger: this.bestuurder.tbxVertegenwoordiger,
            tblVMSWBestuurderDatumActief: util.DateForDatabase(this.bestuurder.iDatumactief),
            tblVMSWBestuurderDatumInactief: util.DateForDatabase(this.bestuurder.iDatumInactief),
            tblVMSWBestuurderOpmerking: opmerking,
            tblVMSWBestuurderVerklaringFMSA: this.bestuurder.uploadfiles[0].uploadFileID,
            tblVMSWBestuurderRijksregisterNummer: this.bestuurder.tbxRijksregisternummer,
            tblVMSWBestuurderOndernemingsnummer: this.bestuurder.tbxOndernemingsnummer,
            tblVMSWBestuurderVasteVertegenwoordigerRijksregisterNummer: this.bestuurder.tbxVertegenwoordigerRijksregnr,
          }
          if (this.$route.params.personid) {
            Vue.set(bestuurderUpdateData, 'tblpersonid', parseInt(this.$route.params.personid))
          }
          this.updateBestuurder(bestuurderUpdateData)
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
    rijksregNrOnChange: function () {
      this.bestuurder.tbxRijksregisternummer = this.bestuurder.tbxRijksregisternummer.replace(/ /g, '')
    },
    vertegenwoordigerrijksregNrOnChange: function () {
      this.bestuurder.tbxVertegenwoordigerRijksregnr = this.bestuurder.tbxVertegenwoordigerRijksregnr.replace(/ /g, '')
    },
  },
}
</script>

<style></style>
